<template>
  <div>
    <v-card class="pa-5 mb-5 elevation-hb">
      <v-row>
        <v-col>
          <h3>Administração</h3>
        </v-col>
      </v-row>
      <v-divider class="my-3"></v-divider>
      <v-row>
        <v-col>
          <v-btn
            @click="syncSeller"
            :loading="loadingSeller"
            :disabled="loadingSeller"
            block
            color="blue darken-1"
            class="white--text"
            >Sincronizar Sellers (VTEX)</v-btn
          >
        </v-col>
        <v-col>
          <v-btn
            class="white--text"
            @click="syncVtex"
            :loading="loadingProduct"
            :disabled="loadingProduct"
            block
            color="teal darken-3"
            >Sincronizar Produtos (VTEX)</v-btn
          >
        </v-col>
        <v-col>
          <v-btn
            @click="syncOrder"
            :loading="loadingOrder"
            :disabled="loadingOrder"
            block
            color="brown darken-1"
            class="white--text"
            >Sincronizar Pedidos(VTEX)</v-btn
          >
        </v-col>
        <v-col>
          <v-btn
            @click="syncCategory()"
            :loading="loadingOrder"
            :disabled="loadingOrder"
            block
            color="primary"
            class="white--text"
            >Sincronizar Categorias(VTEX)</v-btn
          >
        </v-col>
        <v-col>
          <v-btn
            @click="updateProductCategory()"
            :loading="loadingOrder"
            :disabled="loadingOrder"
            block
            color="primary"
            class="white--text"
            >Sincronizar Categorias dos Produtos</v-btn
          >
        </v-col>
        <v-col>
          <v-btn
            @click="syncStock"
            :loading="loadingStock"
            :disabled="loadingStock"
            block
            color="blue darken-2"
            class="white--text"
            >Sincronizar Estoque</v-btn
          >
        </v-col>
        <v-col>
          <v-btn
            @click="syncDropHub"
            :loading="loadingDropHub"
            :disabled="loadingDropHub"
            block
            color="blue darken-2"
            class="white--text"
            >Sincronizar DropHub</v-btn
          >
        </v-col>
        <v-col>
          <v-btn
            color="blue-grey lighten-1 "
            :loading="loading"
            depressed
            dark
            class="space"
            @click="updatePrice()"
            block
          >
            <v-icon class="mr-2">mdi-cash</v-icon>Aualizar Preços
          </v-btn>
        </v-col>
      </v-row>
    </v-card>

    <v-row>
      <v-col>
        <v-card class="pa-5 mb-5 elevation-hb">
          Manutenção de Pedidos
          <v-divider class="my-1"></v-divider>
          <v-text-field v-model="teste" placeholder="Inserir ID do Hubble" />

          <v-btn
            dark
            small
            @click="updateSingleOrder(teste)"
            depressed
            color="blue darken-1"
            class="pa-0 ma-1 rounded-md"
          >
            <v-icon small dark>mdi-sync</v-icon>
          </v-btn>

          <v-btn
            dark
            small
            @click="resyncOrder(teste)"
            depressed
            color="yellow darken-1"
            class="pa-0 ma-1 rounded-md"
          >
            <v-icon small>mdi-alert-rhombus</v-icon>
          </v-btn>
          <v-btn
            dark
            small
            @click="cancelOrder(teste)"
            depressed
            color="red darken-1"
            class="pa-0 ma-1 rounded-md"
          >
            <v-icon small dark>mdi-cart-off</v-icon>
          </v-btn>
        </v-card>
      </v-col>
      <v-col>
        <v-btn @click="recountStock()" block color="blue darken-1" dark
          >Recontar Estoque Reservado</v-btn
        >
      </v-col>
      <v-col></v-col>
    </v-row>
  </div>
</template>

<script>
import axios from 'axios'
import { baseApiUrl, showError } from '@/global'

export default {
  name: 'Integrations',
  data: () => ({
    loadingSeller: false,
    loadingProduct: false,
    loadingOrder: false,
    loadingStock: false,
    loadingDropHub: false,
    teste: null,
    loading: false,
  }),
  methods: {
    syncSeller() {
      this.loadingSeller = true
      const url = `${baseApiUrl}/syncSeller`
      axios
        .get(url)
        .then((res) => {
          this.loadingSeller = false
        })
        .catch(showError)
    },
    syncVtex() {
      this.loadingProduct = true
      const url = `${baseApiUrl}/syncProduct`
      axios
        .get(url)
        .then((res) => {
          this.loadingProduct = false
        })
        .catch(showError)
    },
    syncOrder() {
      this.loadingOrder = true
      const url = `${baseApiUrl}/syncOrders`
      axios
        .get(url)
        .then((res) => {
          this.loadingOrder = false
        })
        .catch(showError)
    },
    updateProductCategory() {
      this.loadingOrder = true
      const url = `${baseApiUrl}/updateProductCategory`
      axios
        .get(url)
        .then((res) => {
          this.loadingOrder = false
        })
        .catch(showError)
    },
    syncCategory() {
      this.loadingOrder = true
      const url = `${baseApiUrl}/syncCategory`
      axios
        .get(url)
        .then((res) => {
          this.loadingOrder = false
        })
        .catch(showError)
    },
    syncStock() {
      this.loadingStock = true
      const url = `${baseApiUrl}/vtex/fullUpdateStock`
      axios
        .get(url)
        .then((res) => {
          this.loadingStock = false
        })
        .catch(showError)
    },
    syncDropHub() {
      this.loadingDropHub = true
      const url = `${baseApiUrl}/seller/drophub/sync`
      axios
        .get(url)
        .then((res) => {
          this.loadingDropHub = false
        })
        .catch(showError)
    },
    updatePrice() {
      const url = `${baseApiUrl}/vtex/updatePrice`
      this.loading = true
      axios
        .get(url)
        .then((data) => {
          this.loading = false
        })
        .catch(showError)
    },
    cancelOrder(orderIdHubble) {
      if (confirm(`Deseja Cancelar ${orderIdHubble}?`)) {
        this.loading = true
        let url = `${baseApiUrl}/order/${orderIdHubble}/cancel`
        axios.get(url).catch(showError)
      }
    },
    resyncOrder(orderIdHubble) {
      if (confirm('Deseja ressincronizar o pedido no Seller?')) {
        this.loading = true
        let url = `${baseApiUrl}/order/${orderIdHubble}/resync`
        axios.post(url).catch(showError)
      }
    },
    updateSingleOrder(orderIdMarketplace) {
      if (confirm('Deseja Atualizar a order?')) {
        this.loading = true
        let url = `${baseApiUrl}/vtex/updateSingleOrder`
        let object = { orderIdMarketplace: orderIdMarketplace }
        axios.post(url, object).catch(showError)
      }
    },
    recountStock() {
      const url = `${baseApiUrl}/seller/stock/recount`
      axios
        .get(url)
        .then(() => {})
        .catch(showError)
    },
  },
}
</script>
